
import React, { useRef, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { HashLink } from 'react-router-hash-link';
import TypingText from './TypingText';
import SEO from '../SEO';
import Footer from './Footer';
import Header from './Header';

const TermsAndCondtion = () => {

  const [showContactInfo, setShowContactInfo] = useState();

  useEffect(() => {
    window.scrollTo(0, 0); // scrolls to top when component mounts
  }, []);
  const hasRun = useRef(false);
  useEffect(() => {
    const navbar = document.getElementById("navbar");

    const media = window.matchMedia("(width <= 1024px)");

    function updateNavbar(e) {
      const isMobile = e.matches;
      const menu_div = document.getElementById("mob_menu");
      if (isMobile) {
        menu_div.style.display = "block";
        navbar.setAttribute("inert", "");
      } else {
        menu_div.style.display = "none";
        navbar.removeAttribute("inert");
      }
    }

    media.addEventListener("change", updateNavbar);
    updateNavbar(media);

    return () => media.removeEventListener("change", updateNavbar);
  }, []);




  const openSidebar = () => {
    const openButton = document.getElementById("open-sidebar-button");
    const navbar = document.getElementById("navbar");


    navbar.classList.add("show");
    openButton.setAttribute("aria-expanded", "true");
    openButton.style.display = "none";
    navbar.removeAttribute("inert");
  };

  const closeSidebar = () => {
    const openButton = document.getElementById("open-sidebar-button");
    const navbar = document.getElementById("navbar");

    if (openButton.getAttribute('aria-expanded') === 'true') {


      navbar.classList.remove('show');
      openButton.setAttribute('aria-expanded', 'false');
      openButton.setAttribute('style', 'display: block;');
      navbar.setAttribute('inert', '');

    }
  };



  return (
    <div>

      {/* <div id="mob_menu">
        <div className="row">
          <div className="col-10" style={{ padding: "1.5rem 2rm" }}>
            <a id="ftt"></a>
          </div>
          <div className="col-2">
            <button id="open-sidebar-button" style={{ marginLeft: "-20px" }} onClick={openSidebar} aria-label="open sidebar" aria-expanded="false" aria-controls="navbar">
              <svg xmlns="http://www.w3.org/2000/svg" height="5vh" viewBox="0 -960 960 960" width="5vh" fill="#050505"><path d="M165.13-254.62q-10.68 0-17.9-7.26-7.23-7.26-7.23-18t7.23-17.86q7.22-7.13 17.9-7.13h629.74q10.68 0 17.9 7.26 7.23 7.26 7.23 18t-7.23 17.87q-7.22 7.12-17.9 7.12H165.13Zm0-200.25q-10.68 0-17.9-7.27-7.23-7.26-7.23-17.99 0-10.74 7.23-17.87 7.22-7.13 17.9-7.13h629.74q10.68 0 17.9 7.27 7.23 7.26 7.23 17.99 0 10.74-7.23 17.87-7.22 7.13-17.9 7.13H165.13Zm0-200.26q-10.68 0-17.9-7.26-7.23-7.26-7.23-18t7.23-17.87q7.22-7.12 17.9-7.12h629.74q10.68 0 17.9 7.26 7.23 7.26 7.23 18t-7.23 17.86q-7.22 7.13-17.9 7.13H165.13Z" /></svg>
            </button>
          </div>
        </div>
      </div>

      <nav id="navbar">
        <ul>
          <li>
            <br /><br /><br />
            <TypingText></TypingText>
            <button id="close-sidebar-button" onClick={closeSidebar} aria-label="close sidebar">
              <svg width="25" height="25" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <line x1="4" y1="4" x2="20" y2="20" stroke="black" strokeWidth="2" strokeLinecap="round" />
                <line x1="20" y1="4" x2="4" y2="20" stroke="black" strokeWidth="2" strokeLinecap="round" />
              </svg>
            </button>
          </li>
          <li className="home-li"><a className="active-link" aria-current="page" id="ft"></a></li>
          <HashLink smooth to="/#price" className="menu">Cost &amp; Plans</HashLink>
          <li >
            <Link to="/process-overview" onClick={() => window.scrollTo(0, 0)}> Process Overview</Link>


          </li>


  <li >
            <Link to="/education" onClick={() => window.scrollTo(0, 0)}> Education</Link>
          </li>

     
               <HashLink smooth to="/#mission" className="menu">Our Mission</HashLink>

          <li onClick={closeSidebar} ><a href="https://sandbox.algocontroller.com" className="menu accent-link">Login / Signup</a></li>


       

        </ul>
      </nav> */}
      <Header></Header>
      <div id="overlay" onClick={closeSidebar} aria-hidden="true"></div>

      <div className="tchead">
        <div className="tcinhead">
          <div style={{ textAlign: "center" }}>
            <h1>
            <b>
              
              Terms and Conditions
              Effective Date: June 2, 2025</b>
              </h1>
              <br /><br />
          </div>
          Welcome to AlgoController.com (“Website”), a platform operated by Raja Yadav, offering tools for algorithmic trading and market automation in India.
          <br />
          By accessing or using this Website, you agree to be legally bound by these Terms and Conditions. If you do not agree, please discontinue use immediately.
          <br /><br />
          <b>1. Eligibility</b><br />
          &nbsp;&nbsp;&nbsp; * You must be at least 18 years of age and legally capable of entering into a binding agreement to use our services.
          <br /><br />
          <b>2. Use of Services</b><br />
          You agree to:<br />

          &nbsp;&nbsp;&nbsp; * Use AlgoController only for lawful and intended purposes.
          <br />
          &nbsp;&nbsp;&nbsp; * Maintain the confidentiality of your account credentials.
          <br />
          &nbsp;&nbsp;&nbsp; * AlgoController.com reserves the right to deny access or terminate accounts at its discretion.
          <br /><br />
          <b>3. Disclaimer of Risk</b><br />
          &nbsp;&nbsp;&nbsp; * Trading involves risk.
          You are solely responsible for your investment decisions.
          AlgoController does not offer investment advice, does not offer any strategy/algo , we are not a registered broker, and assumes no liability for financial loss.
          <br /><br />
          <b>4. Account Registration</b><br />
          When you create an account:<br />

          &nbsp;&nbsp;&nbsp; * You agree to provide accurate and complete information.
          <br />
          &nbsp;&nbsp;&nbsp; * You are responsible for all activity under your account.
          <br />
          &nbsp;&nbsp;&nbsp; * You must notify us immediately if you suspect unauthorized access.
          <br /><br />
          <b>5. Payment, Subscription, and Cancellation</b><br />
          &nbsp;&nbsp;&nbsp; * Some features may require a subscription or one-time payment.
          <br />
          &nbsp;&nbsp;&nbsp; * All fees are displayed in INR and are inclusive/exclusive of GST as applicable.
          <br />
          &nbsp;&nbsp;&nbsp; * Subscriptions auto-renew unless cancelled prior to renewal.
          <br /><br />
          <b>6. Intellectual Property</b><br />
          &nbsp;&nbsp;&nbsp; * All content, tools, designs, and logos on this site are the intellectual property of AlgoController.com and/or its licensors.
          <br />
          You may not:
          <br />
          &nbsp;&nbsp;&nbsp; * Copy, modify, or distribute any part of the site.
          <br />
          &nbsp;&nbsp;&nbsp; * Reverse-engineer or tamper with our tools.
          <br />
          &nbsp;&nbsp;&nbsp; * Use our name, logo, or content without prior written permission.
          <br /><br />
          <b>7. Third-Party Links and Tools</b><br />
          &nbsp;&nbsp;&nbsp; * We may use or link to third-party services (e.g., charting libraries, data providers). We are not responsible for their content, reliability, or security. Use them at your own discretion.
          <br /><br />
          <b>8. Privacy</b><br />
          &nbsp;&nbsp;&nbsp; * Your use of this site is also governed by our Privacy Policy, which explains how we collect, use, and store your data. By using this site, you agree to that policy.
          <br /><br />
          <b>9. Termination</b><br />
          &nbsp;&nbsp;&nbsp; * We reserve the right to suspend or permanently terminate your access for:
          <br />
          Violating these terms:
          <br />
          &nbsp;&nbsp;&nbsp; * Engaging in fraudulent or harmful activities.
          <br />
          &nbsp;&nbsp;&nbsp; * Any misuse of the platform or its resources.
          <br /><br />
          <b>10. Limitation of Liability</b><br />
          &nbsp;&nbsp;&nbsp; * We are not liable for:<br />

          &nbsp;&nbsp;&nbsp; * Any financial loss incurred from using or relying on our content.
          <br />
          &nbsp;&nbsp;&nbsp; * Service disruptions, technical failures, or data errors.
          <br />
          &nbsp;&nbsp;&nbsp; * Indirect, incidental, or consequential damages.
          <br />
          &nbsp;&nbsp;&nbsp; * Our liability, if any, shall not exceed the amount paid by you to us in the last 3 months.
          <br /><br />
          <b>11. Indemnification</b><br />
          &nbsp;&nbsp;&nbsp; * You agree to indemnify and hold harmless AlgoController.com, Raja Yadav, and any team members from any claims, losses, or liabilities resulting from your use of the platform or violation of these terms.
          <br /><br />
          <b>12. Governing Law</b><br />
          &nbsp;&nbsp;&nbsp; * These Terms shall be governed and interpreted in accordance with the laws of India, and subject to the jurisdiction of courts in Rewari, Haryana.
          <br /><br />
          <b>13. Amendments</b><br />
          &nbsp;&nbsp;&nbsp; * We reserve the right to update these Terms at any time. Changes will be posted on this page. Continued use after updates constitutes acceptance.
          <br /><br />
          <b>14. Contact Information</b><br />
          &nbsp;&nbsp;&nbsp; * If you have any questions or need clarification, reach out to us at:
          <b>
            📧 Email: support@algocontroller.com</b>
          <br /><br />
        </div>
      </div>

      <br />



      <div id="myModal" className="modal">
        <div className="modal-content">
          <span className="close" >&times;</span>
          <h2>Hello!</h2>
          <p><b>We’re working hard behind the scenes to bring something great!</b><br />
            Some features and links will be available soon.<br />
            Thank you for your patience — our website is currently under construction.</p>
        </div>
      </div>

      <br /><br />
      {/* <span className="card"></span>

      <section id="footer">
        <div id="footer1">
          <Link to="/terms-condition" onClick={() => window.scrollTo(0, 0)} style={{ textDecoration: "none", color: "black" }}> Terms & Conditions</Link>
          <span> | </span>
          <Link to="/privacy-policy" onClick={() => window.scrollTo(0, 0)} style={{ textDecoration: "none", color: "black" }}> Privacy Policy</Link>
          <span> | </span>

          <Link to="/refund-policy" onClick={() => window.scrollTo(0, 0)} style={{ textDecoration: "none", color: "black" }}> Refund Policy</Link>
          <span className=''> | </span>
          <Link to="/sponsership-disclaimer" onClick={() => window.scrollTo(0, 0)} style={{ textDecoration: "none", color: "black" }}>Sponsership Disclaimer</Link>
          <span> | </span>
          <Link to="/referral" onClick={() => window.scrollTo(0, 0)} style={{ textDecoration: "none", color: "black" }}>  Referral Terms & Conditions   </Link>
          <span> | </span>
       

          <div className="icon-wrapper" id="upgrade">
             <button    onClick={()=>setShowContactInfo(true)}>
        
            
               
              Contact Us
            </button>

              { showContactInfo&&(
           <div className="fixed inset-0 bottom-52 flex items-center justify-center bg-black/40 z-[9999]">
  <div className="bg-white/90 rounded-xl shadow-lg p-2 w-[350px]">
 
    <div className="flex items-center justify-between mb-4">
      <h2 className="text-lg font-semibold text-center flex-1">
        Contact Details
      </h2>
      <button
        className="text-gray-500 hover:text-red-500 text-xl font-bold mb-2"
        onClick={() => setShowContactInfo(false)} 
      >
        ×
      </button>
    </div>

    <div className="space-y-3 text-center">
      <p className="text-gray-700">support@algocontroller.com</p>
      <p className="text-gray-700">+91 8684953093</p>
    </div>
  </div>
</div>



            )

            }
          </div>

        </div> */}

      {/* <div id="footer2">AlgoController automates trade execution by linking your broker and exchange accounts. While powerful, automated trading involves risk. Use with care and ensure you understand the potential impact.

          By using AlgoController, you accept full responsibility for all trading activity and agree to proceed at your own risk.

          We are not liable for any losses, technical issues, or third-party errors. You are responsible for monitoring your trades and
          ensuring proper signal execution.
          <br /><br />
          &#xA9; 2025 AlgoController, All rights reserved. <br />
          Registered MSME (Udyam): UDYAM-HR-15-0030895 ||
          Verified under Ministry of MSME, Govt. of India
        </div>

      </section>

      <a href="https://wa.me/918684953093?text=Hi" target="_blank" className="chaty-tooltip pos-left" data-form="chaty-form-0-Whatsapp" data-hover="Whatsapp">
        <img src="/assets/chaticon.svg" width="40" height="40" id="uparrow"
          style={{
            cursor: "pointer", bottom:
              "0px", right: "20px",
            msTransformOrigin: "100% 100%",
            WebkitTransformOrigin: "100% 100%",
            transformOrigin: "100% 100%",
            zIndex: "9999997",
            position: "fixed"
          }} />
      </a>
 */}

      <Footer></Footer>

    </div>

  )
}

export default TermsAndCondtion